var staticElementObject = [
    {
        id: 1,
        stepName: 'Erikoisala',
        stepNameBig: 'Valitse erikoisala'
    }, {
        id: 2,
        stepName: 'Toimisto',
        stepNameBig: 'Valitse toimipiste'
    }, {
        id: 3,
        stepName: 'Henkilö',
        stepNameBig: 'Valitse henkilö'
    }, {
        id: 4,
        stepName: 'Henkilötiedot',
        stepNameBig: 'Täytä henkilötiedot'
    }, {
        id: 5,
        stepName: 'Vahvistus',
        stepNameBig: 'Confirm appoinment'
    }
];

export default staticElementObject;


// WEBPACK FOOTER //
// ./src/staticElementObject.js